/**
 * ====================================================================
 * WeLearn Pro Player: Default video options configuration
 * Default configurations with comments
 * ====================================================================
 */

/**
 * Default Plyr controls for preview mode
 * @type {string[]}
 */
const previewModeControls = [
    'play-large', // The large play button in the center
    'play', // Play/pause playback
    'progress', // The progress bar and scrubber for playback and buffering
    'current-time', // The current time of playback
    'duration', // The full duration of the media
    'mute', // Toggle mute
    'volume', // Volume control
    'fullscreen', // Toggle fullscreen
];

/**
 * Default Plyr controls for learning mode
 * @type {Array}
 */
const learningModeControls = [
    'play-large', // The large play button in the center
    'play', // Play/pause playback
    'progress', // The progress bar and scrubber for playback and buffering
    'current-time', // The current time of playback
    'duration', // The full duration of the media
    'mute', // Toggle mute
    'volume', // Volume control
    'captions', // Toggle captions
    'settings', // Settings menu
    'fullscreen', // Toggle fullscreen
];

/**
 * Default Plyr settings for learning mode
 *
 * @var {Array}
 */
const learningModeSettings = [
    'captions',
    'quality',
    'loop'
];

/**
 * Defaulr Plyr settings for preview mode
 *
 * @var {Array}
 */
const previewModeSettings = [
    'captions',
    'quality',
    'loop'
];

const plyrControls = {
    previewModeControls,
    learningModeControls
};

const plyrSettings = {
    previewModeSettings,
    learningModeSettings
};

/**
 * Default options for Plyr player that appreciable to WLP player
 * @type {{youtube: {controls: number, playsinline: number, showinfo: number}, debug: boolean, fullscreen: {iosNative: boolean, fallback: boolean, enabled: boolean}, blankVideo: string, ratio: string}}
 */
const plyrWlpOptions = {
    debug: false,
    fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: false
    },
    youtube: {
        playsinline: 1,
        controls: 0,
        showinfo: 0
    },
    ratio: '16:9',
    blankVideo: 'https://cdn.plyr.io/static/blank.mp4',
    controls: [],
    settings: [],
};

export { plyrControls, plyrSettings, plyrWlpOptions };
